import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const SaasDetail = () => {
    return (
        <>
            {/* Career Detail Banner */}
            <section className='about-page'>
                <div className='about-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <div className='career-shap-22'>
                        <img src="../assets/images/whi-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center'>
                            <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                                <div className='career-img text-center  '>
                                    <img src="../assets/images/saas-banner.png" alt="" />
                                </div>
                                <div className='career-shap-1'>
                                    <img src="../assets/images/white-arr.svg" alt="" />
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                                <div className='tech-content'>
                                    <h2>Saas Developer</h2>
                                    <p>Join our product innovation team to build scalable SaaS solutions that solve real-world problems. Collaborate with cross-functional teams to design, develop, and deploy cloud-native applications that are secure, reliable, and built for global scale. </p>
                                    <div className='interest-btn'>
                                        <Link to='/career-form'>
                                            <button className='job-btn'>I’m Interested</button>
                                        </Link>
                                        <Link to='/career-form'>
                                            <button className='friend-btn'>Refer A Friend</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>
    
            {/* Information Section */}
            <section className='information-section'>
                <Container>
                    <Row>
                        <div className="col-md-6 mb-30" data-aos="fade-up-right" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Job Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-1.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Region</p>
                                                <h5>Tamil Nadu</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-2.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Industry</p>
                                                <h5>Technology</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                            <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/saas-career.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Role</p>
                                                <h5>Saas Developer</h5>
                                            </div>
                                        </Box>
                                        

                                    </div>
                                </Row>
                            </div>
                        </div>
                        <div className="col-md-6 mb-30" data-aos="fade-up-left" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Other Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-4.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Education</p>
                                                <h5>UG / PG</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-5.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Passed Out</p>
                                                <h5>2019</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-6.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Salary Range</p>
                                                <h5>₹ 3 to 7 LPA</h5>
                                            </div>
                                        </Box>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
    
            {/* Job Description Section */}
            <section className='job-description-section'>
                <Container>
                    <div className='job-description' data-aos="fade-right" data-aos-duration="2000">
                        <h3>Job Description</h3>
                        <p> We are seeking a passionate and skilled SaaS Developer to join our dynamic team at IMUII. In this role, you'll architect and build scalable cloud-based solutions that address business challenges across industries.</p>
                        <p>You'll collaborate with designers, engineers, and product managers to bring intuitive and reliable features to life. Candidates should be well-versed in SaaS frameworks, API integration, and agile development practices. </p>
                        <p>An eye for clean code, problem-solving, and security-first thinking is essential. The ideal candidate thrives in a fast-paced environment and is always ready to adopt emerging technologies to drive product innovation. </p>
                    </div>
                </Container>
            </section>
    
            {/* Key Responsibility Section */}
            <section className='key-responsibility-section'>
                <Container>
                    <div className='key-responsibility' data-aos="fade-left" data-aos-duration="2000">
                        <h3>Key Responsibility</h3>
                        <ul>
                            <li>
                                <p>Design, develop, and deploy SaaS applications with a focus on scalability and performance. </p>
                            </li>
                            <li>
                                <p>Collaborate with cross-functional teams to translate product vision into actionable features. </p>
                            </li>
                            <li>
                                <p>Ensure security, compliance, and data protection across all stages of development. </p>
                            </li>
                            <li>
                                <p>Optimize code for performance and scalability while maintaining clean architecture. </p>
                            </li>
                            <li>
                                <p>Conduct code reviews, write unit tests, and contribute to continuous integration efforts. </p>
                            </li>
                            <li>
                                <p>Stay updated on emerging SaaS technologies, tools, and best practices</p>
                            </li>
                             <li>
                                <p>Troubleshoot, debug, and resolve technical issues promptly and effectively. </p>
                            </li>
                             <li>
                                <p>Maintain documentation for technical processes, APIs, and system architecture. </p>
                            </li>
                             <li>
                                <p>Participate in agile sprints and provide input during planning and retrospectives. </p>
                            </li>
                        </ul>
                    </div>
    
                    <div className='btn-margin' data-aos="zoom-in" data-aos-duration="2000">
                        <Link to='/career-form'>
                            <button className='interested-btn'>I’m Interested</button>
                        </Link>
                    </div>
                </Container>
            </section>
            
        </>
    )
}

export default SaasDetail
